// extracted by mini-css-extract-plugin
export default {"flex":"Grid_flex__bEvJ8","item":"Grid_item__FSBu1","img":"Grid_img__xcREq","btn":"Grid_btn__Jxj64"};